import React from "react";

import PropTypes from "prop-types";
import classnames from "classnames";
import {
	getComparativeDiscountPercentageByInitialUnitPrice,
} from "shared/payment/helpers/getComparativeDiscount";
import OkLoader from "shared/components/OkLoader";
import Strf from "shared/components/Strf";
import Str from "shared/components/Str";

import {
	PACKAGES_FORM_NAMES,
} from "shared/payment/constants";

const {
	boostPackage,
} = PACKAGES_FORM_NAMES;


const Packages = ({
	isLoading,
	productPackages,
	selectedProductId,
	setSelectedProductPackage,
	toggleVisible,
	onBoostClick,
	className,
}) => (
	<form
		onChange={({ target: { value } }) => setSelectedProductPackage(value)}
		onSubmit={(e) => e.preventDefault()}
		className={classnames(className, {
			"boostpackages-packages": true,
		})}
	>
		<div className="boostpackages-packages-container">
			<OkLoader
				className={classnames({
					"boostpackages-packages-loader": true,
					"boostpackages-packages-loader--show": isLoading,
				})}
				show
			/>

			<div
				className={classnames({
					"boostpackages-packages-radios": true,
					"boostpackages-packages-radios--show": !isLoading,
				})}
			>
				{productPackages.map(
					({
						id, tokensNumber, unitName, unitNamePlural, formattedInitialUnitPrice,
					}) => {
						const discountPercentage =
							getComparativeDiscountPercentageByInitialUnitPrice(
								productPackages,
								id,
							);
						const checked = selectedProductId === id;
						return (
							<label
								htmlFor={`payment-radio-${id}`}
								className={classnames("boostpackages-packages-radio", {
									"boostpackages-packages-radio--checked": checked,
								})}
								key={id}
							>
								{discountPercentage &&
									<div className="boostpackages-packages-radio-save">
										<Strf vars={{ discountPercentage }}>
											Save $discountPercentage
										</Strf>
									</div>
								}
								<input
									id={`payment-radio-${id}`}
									className="boostpackages-packages-radio-input"
									readOnly
									checked={checked}
									name={boostPackage}
									type="radio"
									value={id}
								/>
								<span className="boostpackages-packages-radio-name">
									<div className="boostpackages-packages-radio-number">{tokensNumber}</div>
									<span key="boostpackages-packages-radio-description">{tokensNumber > 1 ? unitNamePlural : unitName}</span>
									{" "}
									{formattedInitialUnitPrice}/ea
								</span>
							</label>
						);
					})
				}
			</div>
		</div>
		<div
			className="boostpackages-packages-button-container"
		>
			<button
				className="boostpackages-packages-boost-now"
				onClick={onBoostClick}
				type="button"
			>
				<Str>CONTINUE</Str>
			</button>
		</div>
		<div
			className="boostpackages-packages-button-container"
		>
			<button
				type="button"
				onClick={toggleVisible}
				className="boostpackages-packages-no-thanks"
			>
				<Str>NO THANKS</Str>
			</button>
		</div>
	</form>
);


Packages.propTypes = {
	isLoading: PropTypes.bool.isRequired,
	productPackages: PropTypes.array.isRequired,
	selectedProductId: PropTypes.string,
	setSelectedProductPackage: PropTypes.func.isRequired,
	onBoostClick: PropTypes.func.isRequired,
	toggleVisible: PropTypes.func.isRequired,
	className: PropTypes.string,
};

Packages.defaultProps = {
	className: "",
	selectedProductId: null,
};

export default Packages;



// WEBPACK FOOTER //
// ./src/apps/boosts/components/ProductPackageScreen/Packages.jsx